import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';



@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  /* BehaviorSubject so AppComponent — which subscribes in ngOnInit AFTER
   * APP_INITIALIZER finishes — receives the current value immediately.
   * With a plain Subject, the loadEnded() emit fires inside the initializer
   * and is missed by the late subscribe, leaving the loading overlay up
   * forever (black screen) once we made the initializer return its Promise
   * chain. */
  loading = new BehaviorSubject<boolean>(true);
  private count : number = 0;


  loadEnded() : void {
    this.count--;
    if (this.count == 0) {
      this.loading.next(false);
    }
  }

  loadInProgress() : void {
    this.count++;
    this.loading.next(true);
  }

}
